import { OverlayKey } from "../control/types"

export const OVERLAY_INFO: Record<
    OverlayKey,
    { description: string; cadence: string; tags: string[]; source: string; previewSrc?: string }
> = {
    heat: {
        description:
            "Active fire detections from MODIS and VIIRS sensors aboard Terra, Aqua, and Suomi NPP.",
        cadence: "Every 3-12 hours",
        tags: ["NASA FIRMS"],
        source: "NASA FIRMS",
        previewSrc: "/images/overlays/heat.webp",
    },
    firePerimeters: {
        description:
            "Active fire perimeters mapped by incident management teams in the US (WFIGS) and Canada (CWFIS).",
        cadence: "Multiple times daily",
        tags: ["WFIGS", "CWFIS"],
        source: "WFIGS · CWFIS",
        previewSrc: "/images/overlays/firePerimeters.webp",
    },
    fireDanger: {
        description:
            "Fire danger rating based on fuel moisture, weather, and greenness. Covers Canada (FDR) and the continental US (WLFP).",
        cadence: "Daily",
        tags: ["CWFIS", "USGS"],
        source: "CWFIS · USGS",
        previewSrc: "/images/overlays/fireDanger.webp",
    },
    elevation: {
        description:
            "ASTER Global Digital Elevation Model (GDEM) colorized by elevation. 30m horizontal resolution.",
        cadence: "Static",
        tags: ["NASA GIBS", "ASTER"],
        source: "NASA GIBS · ASTER",
        previewSrc: "/images/overlays/elevation.webp",
    },
    civilization: {
        description:
            "Landsat-derived global map of man-made impervious surfaces. Highlights urban areas, roads, and structures at risk from wildfire.",
        cadence: "Static (~2019)",
        tags: ["NASA GIBS", "Landsat"],
        source: "NASA GIBS · Landsat",
        previewSrc: "/images/overlays/civilization.webp",
    },
    geostationary: {
        description:
            "Eumetsat geostationary natural-color RGB imagery. Continuous coverage of North America and Europe.",
        cadence: "Every 3 hours",
        tags: ["Eumetsat"],
        source: "Eumetsat",
        previewSrc: "/images/overlays/geostationary.webp",
    },
}
